import { useEffect, useState } from 'react';
import { PRO_PUBLIC_REVEAL_MAX_MS } from '../pages/ProPage/proPublicRevealSafety';

/** Desktop fiche /pro : footer après contenu prêt (prerenderReady ou main stable). */
export function useDeferredDesktopProFooter(enabled: boolean, pathname: string): boolean {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setMounted(false);
      return;
    }

    let cancelled = false;
    let stableTimer: ReturnType<typeof setTimeout> | undefined;
    let lastHeight = -1;

    const isContentReady = () =>
      Boolean((window as Window & { prerenderReady?: boolean }).prerenderReady);

    const scheduleStable = () => {
      if (stableTimer) clearTimeout(stableTimer);
      stableTimer = setTimeout(() => {
        if (!cancelled) setMounted(true);
      }, 600);
    };

    const onResize = () => {
      if (isContentReady()) {
        scheduleStable();
        return;
      }
      const main = document.querySelector<HTMLElement>('.app-shell__content');
      if (!main) return;
      const h = main.offsetHeight;
      if (h === lastHeight) {
        scheduleStable();
        return;
      }
      lastHeight = h;
      if (stableTimer) clearTimeout(stableTimer);
      stableTimer = setTimeout(onResize, 350);
    };

    setMounted(false);
    lastHeight = -1;
    if (isContentReady()) {
      scheduleStable();
    } else {
      onResize();
    }

    const main = document.querySelector<HTMLElement>('.app-shell__content');
    const ro =
      main && typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(() => onResize())
        : null;
    ro?.observe(main!);

    const readyPoll = window.setInterval(() => {
      if (cancelled) return;
      if (isContentReady()) onResize();
    }, 120);

    const maxTimer = setTimeout(() => {
      if (!cancelled) setMounted(true);
    }, PRO_PUBLIC_REVEAL_MAX_MS);

    return () => {
      cancelled = true;
      if (stableTimer) clearTimeout(stableTimer);
      clearTimeout(maxTimer);
      clearInterval(readyPoll);
      ro?.disconnect();
    };
  }, [enabled, pathname]);

  return mounted;
}
